import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/ScrollerItem.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/SearchBar.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%",
      "show-mask": _vm.showMask
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c(__unplugin_components_0, {
    attrs: {
      "placeholder": i18n.tc("653")
    },
    on: {
      "on-ok": _vm.search
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), _vm.isProductionFromcustomer === 0 ? _c('div', {
    staticClass: "bread-crumb font-size-h3-large"
  }, [_c('div', {
    staticClass: "bread-crumb-item",
    on: {
      "click": function ($event) {
        return _vm.changeParent(-1, '');
      }
    }
  }, [_vm._v(i18n.tc("654"))]), _vm._l(_vm.parentList, function (item, index) {
    return [_c('div', {
      staticClass: "bread-crumb-arrow"
    }, [_vm._v(">")]), _c('div', {
      staticClass: "bread-crumb-item",
      on: {
        "click": function ($event) {
          return _vm.changeParent(index, item.id);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])];
  })], 2) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isProductionFromcustomer === 0 && _vm.productTypeList.length > 0,
      expression: "isProductionFromcustomer === 0 && productTypeList.length > 0"
    }],
    staticClass: "spare-type font-size-h3-large"
  }, [_c('Group', _vm._l(_vm.productTypeList, function (item, index) {
    return _c('Cell', {
      key: index,
      attrs: {
        "is-link": "",
        "title": item.name
      },
      nativeOn: {
        "click": function ($event) {
          _vm.parentId = item.id;
        }
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "spare"
  }, [_c(__unplugin_components_1, {
    ref: "scrollerList",
    attrs: {
      "is-px": "",
      "check": _vm.check,
      "show-image": "",
      "ids": _vm.ids,
      "height": _vm.scrollerHight,
      "total": _vm.productList.length
    },
    on: {
      "on-check-ok": function ($event) {
        ;
        _vm.checkList = $event, _vm.currValue = false;
      },
      "on-pullup-loading": _vm.onPullupLoading,
      "on-pulldown-loading": _vm.onPulldownLoading
    }
  }, _vm._l(_vm.productList, function (item, index) {
    return _c(__unplugin_components_2, {
      key: index,
      attrs: {
        "value": item.id,
        "img-url": _vm.replaceMultiImg(item.img_url || '/spa_static_mobile/icon/spare120_120@3x.png')
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.getProduct(item);
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('div', {
      staticClass: "slot-title font-size-h3-large"
    }, [_c('div', {}, [_vm._v(" " + _vm._s(item.name) + " ")])])]), _c('div', {
      attrs: {
        "slot": "extra"
      },
      slot: "extra"
    }, [_c('div', {
      staticClass: "font-size-h4-large"
    }, [_vm._v(i18n.tc("655") + _vm._s(item.code))])]), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('div', {
      staticClass: "slot-content font-size-h4-large"
    }, [_c('div', {}, [_vm._v(i18n.tc("656") + _vm._s(item.category_name))])])])]);
  }), 1)], 1)], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };